import React from 'react';
import { Alert, Snackbar, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { dismissToast } from '../../app/store/uiSlice';

const ToastCenter = () => {
  const dispatch = useDispatch();
  const toasts = useSelector((state) => state.ui.toasts);

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: (theme) => theme.zIndex.snackbar,
        width: { xs: 'calc(100% - 32px)', sm: 420 },
      }}
    >
      {toasts.map((toast) => (
        <Snackbar
          key={toast.id}
          open
          autoHideDuration={3500}
          onClose={() => dispatch(dismissToast(toast.id))}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            severity={toast.severity}
            onClose={() => dispatch(dismissToast(toast.id))}
            sx={{ width: '100%' }}
            variant="filled"
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default ToastCenter;
